var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-page-reel",class:_vm.pos},[_c('div',{staticClass:"left-o"}),_c('div',{staticClass:"left-pole"}),_c('div',{staticClass:"left-reel"}),_vm._m(0),_c('div',{staticClass:"right-reel"}),_c('div',{staticClass:"right-pole"}),_c('div',{staticClass:"right-o"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reel-i"},[_c('div',{staticClass:"reel-i-bg"})])
}]

export { render, staticRenderFns }